import { createDirtyChecker, compareByPaths } from "../../gvc/testNewForm/createDirtyChecker";
import { inputToPolicy } from "../utils";

export function getDirtyChecker(id: string) {
  return createDirtyChecker(id, inputToPolicy, compareByPaths({
    description: { path: "description" },
    targets: { path: ["targetLinks", "target"] },
    targetQuery: { path: "targetQuery" },
    bindings: { path: "bindings" },
    tags: { path: "tags" },
  }));
}
